module.exports = __webpack_public_path__ + "img/activity_bg.2e4678be.png";